import requests from '../util';

const { request } = requests;

const getTask = (
    requestId
) => {
  return request({
    url: `/api/v1/task/getTask?requestId=${requestId}`,
    method: 'get',
    params:{
        requestId
    }
  });
};



const taskApi = {
    getTask,
};

export default taskApi;
